// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/business_purpose.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/business_purpose.proto.
 */
export const file_bfftypes_v1_business_purpose: GenFile = /*@__PURE__*/
  fileDesc("CiJiZmZ0eXBlcy92MS9idXNpbmVzc19wdXJwb3NlLnByb3RvEgtiZmZ0eXBlcy52MSq1AQoPQnVzaW5lc3NQdXJwb3NlEiAKHEJVU0lORVNTX1BVUlBPU0VfVU5TUEVDSUZJRUQQABIbChdCVVNJTkVTU19QVVJQT1NFX05PUk1BTBABEhwKGEJVU0lORVNTX1BVUlBPU0VfQkFUVEVSWRACEiEKHUJVU0lORVNTX1BVUlBPU0VfUFVNUEVEX0hZRFJPEAMSIgoeQlVTSU5FU1NfUFVSUE9TRV9TRUxGX1dIRUVMSU5HEARCQlpAZ2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdHlwZXMvdjE7YmZmdHlwZXN2MWIGcHJvdG8z");

/**
 * BusinessPurpose is the OCCTO business-code acquisition purpose
 * (取得目的) classification for a BusinessMaster (事業者): 通常 / 蓄電池 /
 * 揚水 / 自己託送. Mirrors backend internalapi.v1.BusinessPurpose 1:1.
 *
 * Hosted under bfftypes/v1 (= shared across BFF service packages) so
 * future master / read-side BFF APIs can reuse the same enum without
 * duplicating it per service, following the bfftypes/v1/license_type.proto
 * / area.proto convention. BFF's contract with the frontend is
 * intentionally decoupled from backend internal types.
 *
 * @generated from enum bfftypes.v1.BusinessPurpose
 */
export enum BusinessPurpose {
  /**
   * @generated from enum value: BUSINESS_PURPOSE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 通常
   *
   * @generated from enum value: BUSINESS_PURPOSE_NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * 蓄電池
   *
   * @generated from enum value: BUSINESS_PURPOSE_BATTERY = 2;
   */
  BATTERY = 2,

  /**
   * 揚水
   *
   * @generated from enum value: BUSINESS_PURPOSE_PUMPED_HYDRO = 3;
   */
  PUMPED_HYDRO = 3,

  /**
   * 自己託送
   *
   * @generated from enum value: BUSINESS_PURPOSE_SELF_WHEELING = 4;
   */
  SELF_WHEELING = 4,
}

/**
 * Describes the enum bfftypes.v1.BusinessPurpose.
 */
export const BusinessPurposeSchema: GenEnum<BusinessPurpose> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_business_purpose, 0);

